import { Typography } from '@mui/material';
import { Box, lighten, styled } from '@mui/system';
import UPButton from 'components/button';

export const DashboardContainer = styled(Box)(({ theme }) => ({
  height: '100vh',
  width: '100%',
  display: 'flex',
  margin: '0',
  position: 'relative',
  [theme.breakpoints.down(1000)]: {
    flexDirection: 'column',
    alignItems: 'center',
  },
}));

export const ContractsContainer = styled(Box)(({ theme }) => ({
  width: '35%',
  display: 'flex',
  flexDirection: 'column',
  marginRight: '10px',
  height: 'fit-content',
  [theme.breakpoints.down(1000)]: {
    marginRight: '0px',
    marginBottom: '10px',
    width: '90%',
  },
  [theme.breakpoints.down(420)]: {
    marginRight: '0px',
    marginBottom: '10px',
    width: '100%',
  },
}));

export const ContractsOverview = styled(Box)({
  height: '350px',
});

export const ContractsListParent = styled(Box)(({ theme }) => ({
  height: 'fit-content',
  [theme.breakpoints.down(1000)]: {
    minHeight: '30px',
  },
}));

export const DashboardRightSide = styled(Box)(({ theme }) => ({
  width: '76%',
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.down(1000)]: {
    width: '92%',
  },
}));

export const ShortcutsContainer = styled(Box)(({ theme }) => ({
  height: '20%',
  [theme.breakpoints.down(1000)]: {
    height: 'unset',
    marginBottom: '10px',
  },
}));

export const OldEmployeeContainer = styled(Box)(({ theme }) => ({
  height: '20%',
  [theme.breakpoints.down(1000)]: {
    height: 'unset',
    marginBottom: '10px',
  },
}));

export const EmployeeContainer = styled(Box)(({ theme }) => ({
  marginLeft: '5px',
  borderRadius: '10px',
  width: '50%',
  [theme.breakpoints.down(1000)]: {
    height: 'unset',
    marginBottom: '10px',
    width: '100%',
    marginLeft: '0px',
  },
}));

export const CostEstimationContainer = styled(Box)(({ theme }) => ({
  marginLeft: '5px',
  borderRadius: '10px',
  width: '50%',
  [theme.breakpoints.down(1000)]: {
    display: 'none',
  },
}));

export const BlogContainer = styled(Box)(({ theme }) => ({
  marginLeft: '5px',
  borderRadius: '10px',
  width: '50%',
  [theme.breakpoints.down(1000)]: {
    height: 'unset',
    marginBottom: '10px',
    width: '100%',
    marginLeft: '0px',
    marginTop: '55px',
  },
  [theme.breakpoints.down(670)]: {
    marginTop: '45px',
  },
}));

export const DashboardTilesContainer = styled(Box)(({ theme }) => ({
  height: '50%',
  width: '100%',
  minHeight: '320px',
  display: 'flex',
  [theme.breakpoints.down(1000)]: {
    flexDirection: 'column',
  },
}));

export const DashboardTileStyled = styled(Box)(({ theme }) => ({
  height: '100%',
  width: '100%',
  display: 'flex',
  fontSize: '14px',
  backgroundColor: lighten(theme.palette.secondary.light, 0.8),
  borderRadius: '10px',
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.03)',
  flexDirection: 'column',
  [theme.breakpoints.down(1000)]: {
    minHeight: '300px',
    width: '100%',
  },
}));

export const DashboardTileTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.secondary.main,
  width: '100%',
  height: '15%',
  padding: '0px 10px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  fontWeight: 'bold',
}));

export const AddEmployeeButton = styled(UPButton);

export const BlogsList = styled(Box)(({ theme }) => ({
  height: '100%',
  marginTop: '10px',
  [theme.breakpoints.down(1000)]: {
    height: 'unset',
    marginTop: '10px',
    minHeight: '210px',
  },
}));

export const ErrorDayContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  margin: '10px 0px',
  padding: '10px',
  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.03)',
  borderRadius: '5px',
  backgroundColor: '#fff',
}));

export const ErrorDateStyled = styled(Box)(({ theme }) => ({
  color: theme.palette.primary.dark,
  fontSize: '15px',
  fontWeight: 'bold',
}));

export const ErrorListContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  height: 'auto',
}));

export const ErrorCardStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  margin: '10px 5px',
  padding: '5px 10px',
  backgroundColor: theme.palette.primary.light,
  borderRadius: '5px',
}));

export const ErrorCardTop = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  color: theme.palette.error.main,
}));

export const ErrorCardBottom = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

export const ErrorCardMessage = styled(Typography)(({ theme }) => ({
  fontSize: '26px',
  color: theme.palette.error.main,
}));
